/**
 * Agrupamento do resumo de checkout: os registros da estadia inteira caem no
 * dia a que pertencem. Sem React e sem Supabase, para ser testável direto.
 */

export interface CheckoutActivity {
  id: string;
  day: string;
  time: string;
  typeName: string;
  description: string;
  done: boolean;
}

export interface CheckoutObservation {
  id: string;
  day: string;
  time: string;
  typeName: string;
  description: string;
  isIncident: boolean;
}

export interface CheckoutDay {
  day: string;
  activities: CheckoutActivity[];
  observations: CheckoutObservation[];
}

/**
 * Registro sem horário vai para o fim. Comparação simples de string em vez de
 * `localeCompare`: a colação de alguns locais trata símbolos como
 * ignoráveis, o que bagunçaria um sentinela como "~".
 */
const byTime = <T extends { time: string }>(left: T, right: T) => {
  if (left.time === right.time) return 0;
  if (!left.time) return 1;
  if (!right.time) return -1;
  return left.time < right.time ? -1 : 1;
};

export function buildCheckoutDays(input: {
  days: string[];
  activities: CheckoutActivity[];
  observations: CheckoutObservation[];
}): CheckoutDay[] {
  return input.days.map((day) => ({
    day,
    activities: input.activities.filter((row) => row.day === day).sort(byTime),
    observations: input.observations.filter((row) => row.day === day).sort(byTime),
  }));
}
